<template>
  <div style="width: 100%">
    <div @click="showTimePicker" :light="true" class="wmq-date-picker" :class="colorClass">
      <div class="date-display-style">{{ value || placeholder }}</div>
      <div v-if="value && clearable" class="sprite icon-close wmq-date-picker-clear" style="width: 10%;" @click="reset"></div>
    </div>
    <van-popup
      v-model="showBottom"
      close-icon="close"
      position="bottom"
      class="wmq-date-popup"
      :class="buttonClasses"
    >
      <van-datetime-picker
        v-model="currentDate"
        :type="type"
        :title="title"
        @confirm="onConfirm"
        @cancel="cancelHandle"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'WmqDate',
  props: {
    valueFormatter: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    placeholder: {
      type: String,
      default: '请选择日期'
    },
    title: {
      type: String,
      default: '选择日期'
    },
    type: {
      type: String,
      default: 'date'
    },
    value: {
      type: String,
      default: undefined
    },
    min: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: '9999-12-31'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showBottom: false,
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2099, 11, 31),
      buttonClasses: 'default-mode'
    }
  },
  created() {
    this.checkOrientation() // 创建组件时立即检查一次
    window.addEventListener('resize', this.checkOrientation) // 监听窗口大小变化
  },
  destroyed() {
    window.removeEventListener('resize', this.checkOrientation) // 移除监听器
  },
  computed: {
    colorClass() {
      return this.value ? 'color-black' : 'color-gray'
    }
  },
  methods: {
    /**
     * 监听屏幕旋转
     */
    checkOrientation() {
      const orientation = window.matchMedia('(orientation: landscape)')

      if (orientation.matches) {
        this.buttonClasses = 'landscape-mode'
      } else {
        this.buttonClasses = 'default-mode'
      }
    },
    /**
     * 重置日期选择器的值为当前已选中的值
     */
    resetDatePickerValue() {
      this.currentDate = this.value ? new Date(this.value) : new Date()
    },
    showTimePicker() {
      this.resetDatePickerValue()
      this.showBottom = true
    },
    onConfirm() {
      this.showBottom = false
      const res = this.$dayjs(this.currentDate).format(this.valueFormatter)
      this.$emit('updateValue', res)
    },
    cancelHandle() {
      this.showBottom = false
      this.resetDatePickerValue()
    },
    reset(e) {
      this.$emit('updateValue', undefined)
      e.stopPropagation()
    }
  }
}
</script>

<style lang="stylus" scope>
.wmq-date-picker {
    text-align: left;
    font-size: 28px;
    background-color: #fff;
    border: 1px solid #eee;
    width: 100%;
    display: flex;
    position: relative;
    min-height: 40px;
    height: auto;
    padding: 8px 10px;
    align-items: center;
}
.wmq-date-picker-clear {
    height: 42px;
    width: 42px;
    line-height: 60px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.date-display-style {
    white-space: normal;
    word-break: break-all;
    line-height: 1.5;
    width: 90%;
    font-size: 28px;
}
.color-gray {
    color: #64748b !important
}
.color-black {
    color: #1e293b !important
}
.default-mode{
    height: 40%;
}
.landscape-mode{
    height: 90%;
}
</style>

<style lang="stylus">
/* van-popup 挂载到 body，需全局样式 */
.wmq-date-popup
  .van-picker__toolbar
    height 88px

  .van-picker__cancel,
  .van-picker__confirm
    font-size 28px
    padding 0 32px

  .van-picker__title
    font-size 32px
    font-weight 500
    line-height 88px
    max-width 60%

  .van-picker-column__item
    font-size 28px
    color #1e293b
    padding 0 24px
</style>
